export default "__VITE_ASSET__8c6e00dd__"